// SEO-Konfiguration für verschiedene Routen
export const seoConfig = {
  '/': {
    title: 'Kleinbus mieten Berlin | 9-Sitzer Vermietung | Gruppenbus',
    description:
      'Kleinbus mieten Berlin ✓ 9-Sitzer ✓ MAN, Crafter, Sprinter ✓ günstig & freundlich ✓ Für Urlaub oder Tournee ✓ Mit Führerschein B fahrbar ✓ Versicherung EU-weit',
    keywords:
      'kleinbus mieten berlin, 9-sitzer vermietung, busvermietung berlin, gruppenbus, kleinbus führerschein b, crafter mieten, sprinter mieten',
    ogType: 'website',
    canonicalUrl: 'https://gruppenbus.com/',
  },
  '/busse': {
    title:
      'Unsere 9-Sitzer Busse mieten | VW Crafter, Sprinter, MAN | Gruppenbus',
    description:
      'Entdecken Sie unsere Kleinbus-Flotte: VW Crafter, MAN TGE. 2-9 Personen, Hochdach, großer Kofferraum. Jetzt 9-Sitzer mieten!',
    keywords:
      'vw crafter mieten, sprinter mieten, man tge mieten, 9-sitzer busse, kleinbus hochdach',
    ogType: 'website',
    canonicalUrl: 'https://gruppenbus.com/busse',
  },
  '/kontakt': {
    title: 'Kontakt & Anfahrt | Kleinbusvermietung Berlin | Gruppenbus',
    description:
      'Kontaktieren Sie uns für Ihre Kleinbus-Miete in Berlin. Adresse, Telefon, E-Mail und Anfahrtsbeschreibung zur Gruppenbus Vermietung.',
    keywords:
      'gruppenbus kontakt, kleinbusvermietung berlin adresse, busvermietung berlin telefon',
    ogType: 'website',
    canonicalUrl: 'https://gruppenbus.com/kontakt',
  },
  '/impressum': {
    title: 'Impressum & Datenschutz | Gruppenbus Kleinbusvermietung Berlin',
    description:
      'Impressum und Datenschutzerklärung der Gruppenbus Kleinbusvermietung Berlin. Rechtliche Informationen zur 9-Sitzer Vermietung.',
    keywords: 'gruppenbus impressum, datenschutz kleinbusvermietung',
    ogType: 'website',
    canonicalUrl: 'https://gruppenbus.com/impressum',
  },
  '/agb': {
    title: 'AGB | Allgemeine Geschäftsbedingungen | Gruppenbus',
    description:
      'Allgemeine Geschäftsbedingungen für die Kleinbus-Miete bei Gruppenbus Berlin. Mietbedingungen für 9-Sitzer und Kleinbusse.',
    keywords:
      'gruppenbus agb, mietbedingungen kleinbus, geschäftsbedingungen busvermietung',
    ogType: 'website',
    canonicalUrl: 'https://gruppenbus.com/agb',
  },
};

// Strukturierte Daten für lokales Geschäft
export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': 'https://gruppenbus.com/#organization',
  name: 'Gruppenbus - Kleinbusvermietung Berlin',
  description:
    'Kleinbus und 9-Sitzer Vermietung in Berlin. VW Crafter, Mercedes Sprinter, MAN TGE mit Führerschein B fahrbar.',
  url: 'https://gruppenbus.com',
  telephone: '+493099271837',
  email: 'info@gruppenbus.com',
  priceRange: '€€',
  currenciesAccepted: 'EUR',
  paymentAccepted: 'Cash, Credit Card, Bank Transfer',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Goethestraße 50 - 54, 13086 Berlin',
    postalCode: '13086',
    addressLocality: 'Berlin',
    addressCountry: 'DE',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '52.5535644',
    longitude: '13.4366988',
  },
  openingHours: ['Mo-Fr 09:00-17:00'],
  serviceArea: {
    '@type': 'GeoCircle',
    geoMidpoint: {
      '@type': 'GeoCoordinates',
      latitude: '52.5535644',
      longitude: '13.4366988',
    },
    geoRadius: '100000',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Kleinbus Vermietung',
    itemListElement: [
      {
        '@type': 'Offer',
        name: 'VW Crafter Kleinbus 9-Sitzer',
        description:
          'Kleinbus für 2-9 Personen mit Hochdach und großem Kofferraum',
        category: 'Vehicle Rental',
      },
      {
        '@type': 'Offer',
        name: 'MAN TGE Kleinbus',
        description: 'Moderner 9-Sitzer mit DVD-System',
        category: 'Vehicle Rental',
      },
    ],
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    reviewCount: '127',
    bestRating: '5',
    worstRating: '1',
  },
  sameAs: [
    'https://www.facebook.com/touralarm.tourbusvermietung',
    'https://www.instagram.com/touralarm',
  ],
};

// Service Schema für die Hauptdienstleistung
export const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Kleinbus Vermietung Berlin',
  description:
    'Professionelle Kleinbus und 9-Sitzer Vermietung in Berlin für Gruppenreisen, Urlaub und Events',
  provider: {
    '@id': 'https://gruppenbus.com/#organization',
  },
  areaServed: {
    '@type': 'Country',
    name: 'Deutschland',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Kleinbus Mietangebote',
    itemListElement: [
      {
        '@type': 'Offer',
        name: 'Kurzzeit Kleinbus Miete',
        description: 'Kleinbus mieten ab 1 Tag',
      },
      {
        '@type': 'Offer',
        name: 'Langzeit Kleinbus Miete',
        description: 'Kleinbus mieten für mehrere Wochen',
      },
    ],
  },
};
